import React from 'react';
import { Section } from './Section';
export function PricingSection() {
  return <Section id="pricing" className="bg-bgLight py-24 px-4 sm:px-6 lg:px-8" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <h2 className="font-serif text-4xl md:text-5xl text-center text-headlineDark mb-16" data-id="element-171">
          Elegí tu plan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-172">
          {/* Standard Plan */}
          <div className="bg-bgAlt rounded-3xl p-8 border-2 border-mutedPurple shadow-sm flex flex-col" data-id="element-173">
            <div className="mb-6" data-id="element-174">
              <span className="text-2xl mb-4 block" data-id="element-175">📘</span>
              <h3 className="font-serif text-2xl font-bold text-headlineLight mb-2" data-id="element-176">
                MENTE EN CALMA, NOCHE EN PAZ
              </h3>
              <p className="text-accentText font-semibold mb-4" data-id="element-177">
                6 Módulos + 5 Bonos
              </p>
              <p className="text-sm text-bodyOnDark bg-bgHero/50 p-3 rounded-lg" data-id="element-178">
                <span className="font-semibold" data-id="element-179">Ideal para:</span> Mujeres que
                quieren recuperar el sueño con un sistema completo
              </p>
            </div>

            <div className="mt-auto pt-8 border-t border-[rgba(232,197,245,0.2)]" data-id="element-180">
              <div className="flex items-center gap-3 mb-2" data-id="element-181">
                <span className="line-through text-mutedPurple text-lg" data-id="element-182">
                  $51.000
                </span>
              </div>
              <div className="text-4xl font-bold text-goldSoft mb-6" data-id="element-183">
                $19.990 ARS
              </div>
              <a href="https://librofy-store.myshopify.com/cart/47909760106717:1" className="w-full cta-secondary font-bold py-4 rounded-xl transition-all flex items-center justify-center text-center" data-id="element-184">
                → QUIERO ESTE PLAN
              </a>
            </div>
          </div>

          {/* Recommended Plan */}
          <div className="bg-gradient-to-br from-[#3D1F6E] to-[#2D1B4E] rounded-3xl p-8 border-2 border-ctaFrom shadow-[0_0_40px_rgba(192,132,252,0.3)] flex flex-col relative transform md:-translate-y-4" data-id="element-185">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-ctaFrom text-white font-bold text-xs px-4 py-1.5 rounded-full uppercase tracking-wider -rotate-2" data-id="element-186">
              MÁS ELEGIDO
            </div>

            <div className="mb-6" data-id="element-187">
              <span className="text-2xl mb-4 block" data-id="element-188">🏆</span>
              <h3 className="font-serif text-2xl font-bold text-headlineLight mb-2" data-id="element-189">
                EDICIÓN COMPLETA ⭐
              </h3>
              <p className="text-goldSoft font-semibold mb-4" data-id="element-190">
                6 Módulos + 5 Bonos + Bono Historias Reales
              </p>
              <p className="text-sm text-bodyOnDark bg-bgHero/50 p-3 rounded-lg" data-id="element-191">
                <span className="font-semibold text-goldSoft" data-id="element-192">
                  Historias Reales:
                </span>{' '}
                Tu hoja de ruta para dejar de adivinar. Copiá lo que le funcionó
                a otras mujeres como vos.
              </p>
            </div>

            <div className="mt-auto pt-8 border-t border-[rgba(232,197,245,0.2)]" data-id="element-193">
              <div className="flex items-center gap-3 mb-2" data-id="element-194">
                <span className="line-through text-mutedPurple text-lg" data-id="element-195">
                  $69.000
                </span>
              </div>
              <div className="text-4xl font-bold text-goldSoft mb-6" data-id="element-196">
                $27.990 ARS
              </div>
              <a href="https://librofy-store.myshopify.com/checkouts/cn/hWNDdqQjfKxkzsZWzMYzEvjO/es-ar?_r=AQABFHC1zTlIVM7KTDwsqQ7Vh6W_x8fkGGS09aCJCayKtPA&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389&skip_fade_in=true" className="w-full cta-primary font-bold py-4 rounded-xl transition-all flex items-center justify-center text-center" data-id="element-197">
                → QUIERO LA EDICIÓN COMPLETA
              </a>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl p-6 md:p-10 border border-cardBorder shadow-sm" data-id="element-198">
          <h4 className="font-serif text-xl font-bold text-headlineDark mb-6 text-center flex items-center justify-center gap-2" data-id="element-199">
            <span data-id="element-200">🕊️</span> ¿Qué agrega la Edición Completa?
          </h4>

          <div className="overflow-x-auto mb-8" data-id="element-201">
            <table className="w-full text-sm md:text-base" data-id="element-202">
              <thead data-id="element-203">
                <tr className="border-b border-cardBorder" data-id="element-204">
                  <th className="text-left py-4 font-semibold text-headlineDark w-1/3" data-id="element-205">
                    Situación
                  </th>
                  <th className="text-left py-4 font-semibold text-bodyOnLight w-1/3" data-id="element-206">
                    ❌ Sin Bono Extra
                  </th>
                  <th className="text-left py-4 font-semibold text-headlineDark w-1/3" data-id="element-207">
                    ✅ Con Bono Extra
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-208">
                <tr className="border-b border-cardBorder/50" data-id="element-209">
                  <td className="py-4 text-bodyOnLight pr-4" data-id="element-210">
                    No sabés si el método funciona para alguien como vos
                  </td>
                  <td className="py-4 text-dangerSoft pr-4" data-id="element-211">
                    Te queda la duda
                  </td>
                  <td className="py-4 text-successGreen font-medium" data-id="element-212">
                    Leés 10 casos reales de mujeres argentinas
                  </td>
                </tr>
                <tr className="border-b border-cardBorder/50" data-id="element-213">
                  <td className="py-4 text-bodyOnLight pr-4" data-id="element-214">
                    Necesitás ver el proceso exacto de alguien más
                  </td>
                  <td className="py-4 text-dangerSoft pr-4" data-id="element-215">
                    No tenés referencia
                  </td>
                  <td className="py-4 text-successGreen font-medium" data-id="element-216">
                    Ves qué hicieron exactamente, paso a paso
                  </td>
                </tr>
                <tr data-id="element-217">
                  <td className="py-4 text-bodyOnLight pr-4" data-id="element-218">
                    Querés motivación cuando querés abandonar
                  </td>
                  <td className="py-4 text-dangerSoft pr-4" data-id="element-219">Te cuesta sola</td>
                  <td className="py-4 text-successGreen font-medium" data-id="element-220">
                    Tenés historias reales que te sostienen
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-bgLight rounded-xl p-6" data-id="element-221">
            <p className="font-bold text-headlineDark mb-4" data-id="element-222">
              Bono Extra incluye:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-223">
              <li className="flex items-center gap-2 text-bodyOnLight" data-id="element-224">
                <span className="text-successGreen" data-id="element-225">✅</span> 10 casos reales de
                mujeres argentinas
              </li>
              <li className="flex items-center gap-2 text-bodyOnLight" data-id="element-226">
                <span className="text-successGreen" data-id="element-227">✅</span> Cómo era su noche
                antes
              </li>
              <li className="flex items-center gap-2 text-bodyOnLight" data-id="element-228">
                <span className="text-successGreen" data-id="element-229">✅</span> Qué hicieron
                exactamente
              </li>
              <li className="flex items-center gap-2 text-bodyOnLight" data-id="element-230">
                <span className="text-successGreen" data-id="element-231">✅</span> Qué cambió en su
                vida cotidiana
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}